"use strict";
const global = {
  announcementBar: "announcement-bar",
  overlay: ".bls__overlay",
  header: "header",
  mobile_stickybar: "shopify-section-mobile-stickybar",
};
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';

window.addEventListener('load', function () {
  // ✅ Read both layout values in one pass — no interleaving
  const bodyClientWidth = document.body.clientWidth;
  const padding = window.innerWidth - bodyClientWidth;
  if (padding > 0) {
    document.querySelector('html').setAttribute('style', `--padding-right: ${padding}px`);
  }
});

function throttle(fn, delay = 100) {
  let last = 0;
  return (...args) => {
    const now = Date.now();
    if (now - last >= delay) {
      last = now;
      fn(...args);
    }
  };
}

function percentageSeen(el) {
  const rect = el.getBoundingClientRect();
  const viewport = window.innerHeight;
  if (rect.top > viewport) return 0;
  if (rect.bottom < 0) return 100;
  return Math.round((viewport - rect.top) / ((viewport + rect.height) / 100));
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : '';
}

function HoverIntent(elements, {onEnter, onExit, interval = 100, sensitivity = 6, exitDelay = 180}) {
  let mouseX = 0;
  let mouseY = 0;

  document.addEventListener("mousemove", e => {
    mouseX = e.pageX;
    mouseY = e.pageY;
  });

  elements.forEach(el => {
    let prevX, prevY, timer;

    el.addEventListener("mouseenter", e => {
      prevX = e.pageX;
      prevY = e.pageY;

      timer = setInterval(() => {
        const dist = Math.hypot(mouseX - prevX, mouseY - prevY);
        if (dist < sensitivity) {
          clearInterval(timer);
          onEnter(el);
        }
        prevX = mouseX;
        prevY = mouseY;
      }, interval);
    });

    el.addEventListener("mouseleave", () => {
      clearInterval(timer);
      setTimeout(() => onExit(el), exitDelay);
    });
  });
}

var menuItems = document.querySelectorAll('.bls__menu-parent');
var menuDropdown1 = document.querySelectorAll('.dropdown li.level-1');
var menuDropdown2 = document.querySelectorAll('.dropdown li.level-2');

const menuElements = document.querySelectorAll(
  '.bls__menu-parent, .dropdown li.level-1, .dropdown li.level-2'
);

HoverIntent(menuElements, {
  onEnter(targetItem) { targetItem.classList.add('visible'); },
  onExit(targetItem)  { targetItem.classList.remove('visible'); }
});

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// ✅ FIX: Cache scrollHeight and back-to-top element
let _cachedScrollHeight = null;
let _cachedBackTopEl = null;

function backToTop() {
  // ✅ Cache the element — don't query DOM on every scroll
  if (!_cachedBackTopEl) {
    _cachedBackTopEl = document.getElementById("bls__back-top");
  }
  if (!_cachedBackTopEl) return;

  const scroll = window.scrollY;

  // ✅ Cache scrollHeight — invalidate on resize
  if (_cachedScrollHeight === null) {
    _cachedScrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    window.addEventListener("resize", () => {
      _cachedScrollHeight = null;
      _cachedBackTopEl = null;
    }, { passive: true });
  }

  _cachedBackTopEl.style.height = (_cachedScrollHeight > 0 ? (scroll / _cachedScrollHeight) * 100 : 0) + "%";
}

// ✅ FIX: Cache header heights and sticky bar element
let _cachedHeaderHeight = null;
let _cachedStickyBar = null;

function mobileStickyBar() {
  // ✅ Cache the element — don't query DOM on every scroll
  if (!_cachedStickyBar) {
    _cachedStickyBar = document.querySelector(".bls__mobile-stickybar");
  }
  if (!_cachedStickyBar) return;

  // ✅ Cache header heights — invalidate on resize
  if (_cachedHeaderHeight === null) {
    _cachedHeaderHeight =
      (document.getElementById("announcement-bar")?.clientHeight || 0) +
      (document.getElementById("shopify-section-top-bar")?.clientHeight || 0) +
      (document.getElementById("page-header")?.clientHeight || 0) + 50;
    window.addEventListener("resize", () => {
      _cachedHeaderHeight = null;
      _cachedStickyBar = null;
    }, { passive: true });
  }

  _cachedStickyBar.classList.toggle("d-none", window.scrollY <= _cachedHeaderHeight);
}
function setCookie(cname, cvalue, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// ✅ FIX: showAnime — read height BEFORE writing any styles
// Old code wrote el.style.display = "block" first, then called getBoundingClientRect()
// which forced an immediate reflow to recalculate layout
function showAnime(el) {
  // ✅ Step 1: Read all layout values BEFORE any writes
  el.style.display = "block";
  const styles = getComputedStyle(el);
  const props = {
    height: el.getBoundingClientRect().height + "px",
    marginTop: styles.marginTop,
    marginBottom: styles.marginBottom,
    paddingTop: styles.paddingTop,
    paddingBottom: styles.paddingBottom
  };

  // ✅ Step 2: Now do all writes together
  el.style.overflow = "hidden";
  Object.keys(props).forEach(p => el.style[p] = 0);

  el.animate(props, { duration: 400, easing: "ease" }).finished.then(() => {
    el.style.overflow = "";
    Object.keys(props).forEach(p => el.style[p] = "");
  });
}

// ✅ FIX: hideAnime — batch reads before writes (same pattern)
function hideAnime(el) {
  // ✅ Step 1: Read everything first
  const styles = getComputedStyle(el);
  const props = {
    height: el.getBoundingClientRect().height + "px",
    marginTop: styles.marginTop,
    marginBottom: styles.marginBottom,
    paddingTop: styles.paddingTop,
    paddingBottom: styles.paddingBottom
  };

  // ✅ Step 2: Write together
  el.style.overflow = "hidden";
  Object.keys(props).forEach(p => el.style[p] = props[p]);

  const end = {};
  Object.keys(props).forEach(p => end[p] = 0);

  el.animate(end, { duration: 300, easing: "ease" }).finished.then(() => {
    el.style.display = "none";
    el.style.overflow = "";
    Object.keys(props).forEach(p => el.style[p] = "");
  });
}

// ✅ FIX: slideAnime — read offsetHeight BEFORE changing display
// Old code read offsetHeight while display might be mid-change
const slideAnime = ({ target, animeType = "slideToggle", duration = 400, easing = "ease", display = "block" }) => {
  if (!target) return;

  const style = getComputedStyle(target);

  if (animeType === "slideToggle") {
    animeType = style.display === "none" ? "slideDown" : "slideUp";
  }

  if (animeType === "slideDown") {
    // ✅ For slideDown: set display first so we can measure natural height,
    // then immediately set to 0 before browser paints (same frame = no reflow)
    target.style.display = display;
    const h = target.offsetHeight;  // read right after display change, before any other writes

    const props = {
      height: h + "px",
      marginTop: style.marginTop,
      marginBottom: style.marginBottom,
      paddingTop: style.paddingTop,
      paddingBottom: style.paddingBottom
    };

    // ✅ Batch all writes
    target.style.overflow = "hidden";
    Object.keys(props).forEach(p => target.style[p] = 0);

    target.animate(props, { duration, easing }).finished.then(() => {
      target.style.overflow = "";
      Object.keys(props).forEach(p => target.style[p] = "");
    });

  } else {
    // ✅ slideUp: read current dimensions first, then write
    const props = {
      height: target.offsetHeight + "px",
      marginTop: style.marginTop,
      marginBottom: style.marginBottom,
      paddingTop: style.paddingTop,
      paddingBottom: style.paddingBottom
    };

    const end = {};
    Object.keys(props).forEach(p => end[p] = 0);

    // ✅ Now batch all style writes
    target.style.overflow = "hidden";
    Object.keys(props).forEach(p => target.style[p] = props[p]);

    target.animate(end, { duration, easing }).finished.then(() => {
      target.style.display = "none";
      target.style.overflow = "";
      Object.keys(props).forEach(p => target.style[p] = "");
    });
  }
};

const BlsEventShopify = (() => {

  const handleScroll = throttle(() => {
    backToTop();
    mobileStickyBar();
  }, 100);

  const setupEventListeners = () => {

    window.addEventListener("scroll", handleScroll, { passive: true });

    document.querySelectorAll(".collection-infinite-scroll a").forEach(btn => {
      btn.addEventListener("click", () => {
        document.querySelectorAll(".collection-list__item.grid__item")
          .forEach(item => item.classList.remove("d-none"));
        btn.parentElement.remove();
      });
    });

    document.querySelectorAll(".bls__footer_block-title").forEach(footer => {
      footer.addEventListener("click", e => {
        const parent = e.currentTarget.parentElement;
        const content = parent.querySelector(".bls__footer_block-content");
        slideAnime({ target: content, animeType: "slideToggle" });
        parent.classList.toggle("active");
      });
    });

    const stickyBar = document.getElementById(global.mobile_stickybar);
    const footer = document.querySelector("footer");
    if (stickyBar && footer) {
      footer.classList.add("enable_menu-bottom");
    }

    const cookieBar = document.getElementById("bls_cookie");
    if (cookieBar && !getCookie("cookie_bar")) {
      cookieBar.classList.remove("d-none");
      cookieBar.querySelectorAll(".cookie-dismiss").forEach(btn => {
        btn.addEventListener("click", e => {
          e.preventDefault();
          cookieBar.remove();
          setCookie("cookie_bar", "dismiss", 30);
        });
      });
    }

    const announcementBar = document.getElementById(global.announcementBar);
    if (announcementBar) {
      const swiperContainer = announcementBar.querySelector(".swiper-announcementBar");

      if (swiperContainer && window.Swiper) {
        // ✅ Read offsetHeight once, store it — don't re-read inside Swiper init
        const abHeight = announcementBar.offsetHeight;
        swiperContainer.style.maxHeight = abHeight + "px";

        new Swiper(".swiper-announcementBar", {
          loop: true,
          slidesPerView: 1,
          direction: "vertical",
          autoplay: { delay: 3000 },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      }

      announcementBar.querySelectorAll(".countdown-announcementBar").forEach(cd => {
        const dateString = cd?.dataset.blockDeadline;
        if (!dateString) return;

        const parts = dateString.split("-");
        const isoDate = `${parts[2]}-${parts[0].padStart(2,"0")}-${parts[1].padStart(2,"0")}T00:00:00Z`;
        if (!Date.parse(isoDate)) return;

        const deadline = new Date(isoDate);

        const updateCountdown = () => {
          const diff = deadline - new Date();
          if (diff <= 0) return;

          const time = {
            days_announcementBar: Math.floor(diff / 86400000),
            hours_announcementBar: Math.floor(diff / 3600000 % 24),
            minutes_announcementBar: Math.floor(diff / 60000 % 60),
            seconds_announcementBar: Math.floor(diff / 1000 % 60)
          };

          Object.entries(time).forEach(([k,v]) => {
            const el = cd.querySelector("." + k);
            if (el) el.textContent = v;
          });
        };

        setInterval(updateCountdown, 1000);
      });

      if (getCookie("announcement_bar")) {
        announcementBar.classList.add("d-none");
      }

      announcementBar.querySelectorAll(".announcement-close").forEach(btn => {
        btn.addEventListener("click", e => {
          e.preventDefault();
          announcementBar.remove();
          setCookie("announcement_bar", 1, 1);
        });
      });
    }

    const conditions = document.getElementById("product_conditions_form");
    const paymentBtn = document.querySelector(".bls__payment-button");

    if (conditions) {
      if (getCookie("term_conditions")) {
        conditions.checked = true;
        paymentBtn?.classList.remove("disabled");
      }
      conditions.addEventListener("change", e => {
        setCookie("term_conditions", 1, 1);
        paymentBtn?.classList.toggle("disabled", !e.currentTarget.checked);
      });
    }

    document.querySelectorAll(global.overlay).forEach(el => {
      el.addEventListener("click", () => {
        document.documentElement.classList.remove("hside_opened","vetical-overlay");
        el.classList.add("d-none-overlay");
        document.querySelectorAll(".bls__opend-popup,.bls__addon,.vertical-menu")
          .forEach(i => i.classList.remove("bls__opend-popup","is-open","open"));
        document.querySelector(".btn-filter")?.classList.remove("actived");
        document.querySelectorAll(".bls-minicart-wrapper")
          .forEach(i => i.classList.remove("addons-open"));
      });
    });

    document.querySelectorAll(".bls__terms-conditions a").forEach(link => {
      link.addEventListener("click", e => {
        const content = document.getElementById("popup-terms-conditions");
        if (!content) return;
        e.preventDefault();
        const text = content.dataset.text;
        const modal = EasyDialogBox.create(
          "popup-terms-conditions",
          "dlg dlg-disable-footer dlg-disable-drag",
          text,
          content.innerHTML
        );
        modal.onClose = modal.destroy;
        modal.show(300);
      });
    });
  };

  return {
    init() {
      setupEventListeners();
      Shopify.eventCountDownTimer?.();
      Shopify.eventFlashingBrowseTab?.();
    }
  };
})();
BlsEventShopify.init();

let newParser = new DOMParser();
var BlsSettingsSwiper = (function () {
  return {
    init: function () {
      this.BlsSettingsCarousel();
    },
    BlsSettingsCarousel: function () {
      var _this = this;
      document.querySelectorAll(".bls__swiper").forEach((element) => {
        _this.BlsCarousel(element);
      });
    },
    BlsCarousel: function (e) {
      var sliderGlobal;
      const autoplay = e.dataset.autoplay === "true";
      var loop = e?.dataset.loop === "true";
      var dataSlideshow = e?.dataset.slideshow ? e?.dataset.slideshow : 0;
      var dataArrowCenterImage = e?.dataset.arrowCenterimage ? e?.dataset.arrowCenterimage : 0;
      var itemDesktop = e?.dataset.desktop ? e?.dataset.desktop : 4;
      var itemTablet = e?.dataset.tablet ? e?.dataset.tablet : 2;
      var itemMobile = e?.dataset.mobile ? e?.dataset.mobile : 1;
      var autoplaySpeed = e?.dataset.autoplaySpeed ? e?.dataset.autoplaySpeed : 3000;
      var speed = e?.dataset.speed ? e?.dataset.speed : 400;
      var effect = e?.dataset.effect ? e?.dataset.effect : "slide";
      var sectionId = e?.dataset.sectionId;
      var row = e?.dataset.row ? e?.dataset.row : 1;
      var spacing = e?.dataset.spacing ? e?.dataset.spacing : 0;
      var progressbar = e?.dataset.paginationProgressbar === "true";
      var animateSrcoll = e?.dataset.animationSrcoll === "true";
      var width = window.innerWidth;
      var autoItem = e?.dataset.itemMobile === "true";
      spacing = Number(spacing);
      autoplaySpeed = Number(autoplaySpeed);
      speed = Number(speed);
      var autoplaying;
      if (autoplay) {
        autoplaying = { delay: autoplaySpeed };
      }

      sliderGlobal = new Swiper("#bls__swiper-" + sectionId, {
        slidesPerView: autoItem ? "auto" : itemMobile,
        spaceBetween: spacing >= 15 ? 15 : spacing,
        autoplay: autoplaying,
        loop: loop,
        effect: effect,
        speed: speed,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        grid: { rows: row, fill: "row" },
        navigation: {
          nextEl: e.querySelector(".swiper-button-next"),
          prevEl: e.querySelector(".swiper-button-prev"),
        },
        pagination: {
          clickable: true,
          el: e.querySelector(".swiper-pagination"),
          type: progressbar ? "progressbar" : "bullets",
        },
        breakpoints: {
          768: {
            slidesPerView: itemTablet,
            spaceBetween: spacing >= 30 ? 30 : spacing,
          },
          1200: {
            slidesPerView: itemDesktop,
            spaceBetween: spacing,
          },
        },
        on: {
          init: function () {
            if (dataSlideshow) {
              if (width > 767) {
                document.querySelectorAll(".slide-image").forEach((img) => {
                  var dataImageSlide = img?.dataset.imgSlide;
                  const image = document.createElement("img");
                  image.src = dataImageSlide;
                  image.loading = "lazy";
                  img.appendChild(image);
                });
              } else {
                if (document.querySelector(".slide-image-mobile")) {
                  document.querySelectorAll(".slide-image-mobile").forEach((imgMobile) => {
                    var dataImageSlideMobile = imgMobile?.dataset.imgSlideMobile;
                    imgMobile.innerHTML = `<img src=${dataImageSlideMobile} alt="slide mobile" srcset="${dataImageSlideMobile}&amp;width=375 375w, ${dataImageSlideMobile}&amp;width=550 550w, ${dataImageSlideMobile}&amp;width=750 750w, ${dataImageSlideMobile}&amp;width=1100 1100w, ${dataImageSlideMobile}&amp;width=1500 1500w, ${dataImageSlideMobile}&amp;width=1780 1780w, ${dataImageSlideMobile}&amp;width=2000 2000w, ${dataImageSlideMobile}&amp;width=3000 3000w, ${dataImageSlideMobile}&amp;width=3840 3840w" sizes="100vw">`;
                  });
                } else {
                  document.querySelectorAll(".slide-image").forEach((img) => {
                    var dataImageSlide = img?.dataset.imgSlide;
                    const image = document.createElement("img");
                    image.src = dataImageSlide;
                    image.loading = "lazy";
                    img.appendChild(image);
                  });
                }
              }

              window.addEventListener("resize", function () {
                const resizeWidth = window.innerWidth;
                if (resizeWidth <= 767) {
                  if (document.querySelector(".slide-image-mobile")) {
                    document.querySelectorAll(".slide-image-mobile").forEach((imgMobile) => {
                      var dataImageSlideMobile = imgMobile?.dataset.imgSlideMobile;
                      imgMobile.innerHTML = `<img src=${dataImageSlideMobile} alt="slide mobile" srcset="${dataImageSlideMobile}&amp;width=375 375w, ${dataImageSlideMobile}&amp;width=550 550w, ${dataImageSlideMobile}&amp;width=750 750w, ${dataImageSlideMobile}&amp;width=1100 1100w, ${dataImageSlideMobile}&amp;width=1500 1500w, ${dataImageSlideMobile}&amp;width=1780 1780w, ${dataImageSlideMobile}&amp;width=2000 2000w, ${dataImageSlideMobile}&amp;width=3000 3000w, ${dataImageSlideMobile}&amp;width=3840 3840w" sizes="100vw">`;
                    });
                  } else {
                    document.querySelectorAll(".slide-image").forEach((img) => {
                      var dataImageSlide = img?.dataset.imgSlide;
                      const image = document.createElement("img");
                      image.src = dataImageSlide;
                      image.loading = "lazy";
                      img.appendChild(image);
                    });
                  }
                } else {
                  document.querySelectorAll(".slide-image").forEach((img) => {
                    var dataImageSlide = img?.dataset.imgSlide;
                    const image = document.createElement("img");
                    image.src = dataImageSlide;
                    image.loading = "lazy";
                    img.appendChild(image);
                  });
                }
              });

              if (animateSrcoll) {
                initializeScrollZoomAnimationTrigger();
              }
            }

            if (dataArrowCenterImage) {
              var swiper = document.getElementById("bls__swiper-" + sectionId);
              var items_slide = swiper.querySelectorAll(".bls__responsive-image");
              if (items_slide.length !== 0) {
                // ✅ FIX: Batch READ all offsetHeights first, then WRITE style once
                var max = 0;
                items_slide.forEach((el) => {
                  const h = el.offsetHeight / 2;
                  if (h > max) max = h;
                });
                var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
                swiper.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                  arrow.setAttribute('style', arrowsOffset);
                });
              }
            }
          },
        },
      });

      if (dataSlideshow) {
        sliderGlobal.on("slideChange", function () {
          document.querySelectorAll(".video-slider").forEach((video) => {
            var dataVideo = video.dataset.video;
            var dataPoster = video.dataset.poster;
            video.innerHTML = `<video playsinline="true" loop="loop" muted="muted" autoplay="autoplay" preload="metadata" poster="${dataPoster}"><source src="${dataVideo}" type="video/mp4"></video>`;
          });
        });
      }
    },
  };
})();
BlsSettingsSwiper.init();

var BlsToggle = (function () {
  return {
    init: function () {
      this.initToggle();
      this.backToTop();
      this.initToggleLookbook();
    },
    initToggle: function () {
      var faq_parent = ".bls__page-faq-items > .bls__page-faq-title";
      document.querySelectorAll(faq_parent).forEach((item) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          const parent = target.parentElement;
          const faqContent = parent.querySelector(".bls__page-faq-content");
          slideAnime({ target: faqContent, animeType: "slideToggle" });
          const toggle = item.closest(".bls-toggle");
          toggle.classList.toggle("active");
        });
      });
    },
    backToTop: function () {
      const b = document.querySelector(".back-top");
      if (b) {
        document.addEventListener("scroll", throttle(() => {
          b.classList.toggle("show", window.scrollY > 400);
        }, 100));
        b.addEventListener("click", () => {
          window.scrollTo({ top: 0, behavior: "smooth" });
        });
      }
    },
    initToggleLookbook: function () {
      document.body.addEventListener("click", (evt) => {
        const target = evt.target;
        if (
          !target.closest(".bls__product-item") &&
          target !== document.querySelector(".bls__product-item.active .lookbook__popup-items")
        ) {
          document.querySelectorAll(".bls__product-item").forEach((items) => {
            items.classList.remove("active","top","bottom","left","right","center");
          });
        }
      });
      document.body.addEventListener("click", this.onBodyClick);
      const lookbook = document.querySelectorAll(".lookbook-action");
      lookbook.forEach((action) => {
        action.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const item = target.closest(".bls__product-item");
          const lookbook_item = item.querySelector(".lookbook__popup-items");

          // ✅ FIX: Batch ALL reads before any writes
          const rect = item.getBoundingClientRect();
          const rect_item = lookbook_item.getBoundingClientRect();
          const item_right = rect_item.right;
          const item_left = rect_item.left;
          const height = window.innerHeight;
          const width = window.innerWidth;
          const top = rect.top;

          const lookbook_items = document.querySelectorAll(".bls__product-item");

          if (!item.classList.contains("active")) {
            // ✅ First all reads are done above, now all writes:
            lookbook_items.forEach((items) => {
              items.classList.remove("active","top","bottom","left","right","center");
            });
            item.classList.add("active");

            if (width > 767) {
              let pos_l = "center";
              if (item_right > width) pos_l = "left";
              else if (item_left < 0) pos_l = "right";
              item.classList.add(top > height / 2 ? "top" : "bottom", pos_l);
            } else {
              item.classList.add(top > height / 2 ? "top" : "bottom");
              let left = 0;
              if (item_right > width) {
                left = -50 - (item_right - width);
                lookbook_item.style.left = left + "px";
              } else if (item_left < 0) {
                left = -item_left;
                lookbook_item.style.left = left + "px";
              }
            }
          } else {
            item.classList.remove("active","top","bottom","left","right","center");
          }
        });
      });
    },
  };
})();
BlsToggle.init();

var BlsPopup = (function () {
  const parser = new DOMParser();
  const cookieCache = {};

  return {
    init: function () {
      if (document.readyState === 'complete') {
        this._initDeferred();
      } else {
        window.addEventListener('load', () => this._initDeferred(), { once: true });
      }
      this.checkFormInfo();
      this.checkShowMsgStockNotify();
    },

    _initDeferred: function () {
      const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 200));
      idle(() => {
        this.fetchDataNewletter();
        this.fetchDataPromotion();
      });
    },

    setCookie: function (cname, exdays, cvalue) {
      const date = new Date();
      date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
      document.cookie = `${cname}=${cvalue};expires=${date.toUTCString()};path=/`;
      cookieCache[cname] = cvalue;
    },

    getCookie: function (cname) {
      if (cookieCache[cname] !== undefined) return cookieCache[cname];
      const match = document.cookie.split(';').find(c => c.trim().startsWith(cname + '='));
      const value = match ? match.trim().substring(cname.length + 1) : '';
      cookieCache[cname] = value;
      return value;
    },

    deleteCookie: function (cname) {
      document.cookie = `${cname}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      delete cookieCache[cname];
    },

    fetchDataNewletter: function () {
      if (this.getCookie('bls-newsletter-popup') !== '') return;
      if (window.popup?.newsletterPopup === false) return;

      const url = `${window.location.pathname}?section_id=newsletter-popup`;
      const _this = this;

      fetch(url)
        .then(r => r.text())
        .then(responseText => {
          const html = parser.parseFromString(responseText, 'text/html');
          const n = html.querySelector('#bls__newsletter-popup');
          if (!n) return;
          const c = n.dataset.show;
          const disableMobile = n.dataset.showMobile === 'true';
          if (c !== 'show-on-all-pages' && c !== 'show-on-homepage') return;
          var newsletter = EasyDialogBox.create(
            'newsletterp',
            `dlg dlg-disable-footer dlg-disable-drag ${disableMobile ? 'dlg-disable-mobile' : ''}`,
            '',
            n.innerHTML
          );
          newsletter.onClose = newsletter.destroy;
          newsletter.show(1000);
          newsletter.onShow = () => _this.checkNotShowNewletter();
        })
        .catch(console.error);
    },

    checkNotShowNewletter: function () {
      const _this = this;
      const check = document.getElementById('doNotShow');
      if (!check) return;
      check.addEventListener('change', (e) => {
        if (e.currentTarget.checked) {
          _this.setCookie('bls-newsletter-popup', 99999, 'bls');
        } else {
          _this.deleteCookie('bls-newsletter-popup');
        }
      });
    },

    fetchDataPromotion: function () {
      if (this.getCookie('bls-promotion-popup') !== '') return;
      if (window.popup?.promotionPopup === false) return;

      const url = `${window.location.pathname}?section_id=promotion-popup`;
      const _this = this;

      fetch(url)
        .then(r => r.text())
        .then(responseText => {
          const html = parser.parseFromString(responseText, 'text/html');
          const p = html.querySelector('#bls__promotion-popup');
          if (!p) return;
          const s = p.dataset.show;
          const m = p.dataset.showMb === 'true';
          if (s !== 'show-on-all-pages' && s !== 'show-on-homepage') return;
          var promotion = EasyDialogBox.create(
            'promotionp',
            `dlg dlg-disable-footer ${m ? '' : 'dlg-disable-mobile'} dlg-disable-drag`,
            '',
            p.innerHTML
          );
          promotion.onClose = promotion.destroy;
          promotion.show(6000);
          promotion.onShow = function () {
            _this.copyPromotion();
            _this.checkNotShowPromotion();
          };
        })
        .catch(console.error);
    },

    checkNotShowPromotion: function () {
      const _this = this;
      const check = document.querySelector('#doNotShowPromotion');
      if (!check) return;
      check.addEventListener('change', (e) => {
        if (e.currentTarget.checked) {
          _this.setCookie('bls-promotion-popup', 1, 'bls');
        } else {
          _this.deleteCookie('bls-promotion-popup');
        }
      });
    },

    copyPromotion: function () {
      const cp = document.querySelectorAll('.discount');
      if (!cp.length) return;
      cp.forEach(e => {
        e.addEventListener('click', (el) => {
          el.preventDefault();
          navigator.clipboard?.writeText(e.dataset.code).then(() => {
            e.classList.add('action-copy');
            setTimeout(() => e.classList.remove('action-copy'), 1500);
          });
        });
      });
    },

    checkFormInfo: function () {
      const urlInfo = window.location.href;
      const hasRelevantParam =
        urlInfo.includes('customer_posted=true') ||
        urlInfo.includes('contact%5Btags%5D=newsletter') ||
        urlInfo.includes('contact_posted=true#askquestion');

      if (!hasRelevantParam) {
        const fi = document.querySelector('.form-infor,.close-form-info');
        if (fi) {
          fi.addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.closest('.form-infor')?.classList.remove('show-noti-form');
          });
        }
        return;
      }

      const _this = this;
      const formInfo = document.querySelector('.form-infor');
      const formErr = document.querySelector('.form-infor-body.noti-error');
      const formSuccess = document.querySelector('.form-infor-body.noti-success');
      const fi = document.querySelector('.form-infor,.close-form-info');

      if (fi) {
        fi.addEventListener('click', (e) => {
          e.preventDefault();
          e.currentTarget.closest('.form-infor')?.classList.remove('show-noti-form');
        });
      }

      const newURL = location.href.split('?')[0];

      if (urlInfo.includes('customer_posted=true#newsletter-form-popup')) {
        formInfo?.classList.add('show-noti-form');
        if (formErr) formErr.style.display = 'none';
        _this.setCookie('bls-newsletter-popup', 99999, 'bls');
        window.history.pushState('object', document.title, newURL);
      } else if (urlInfo.includes('contact%5Btags%5D=newsletter&form_type=customer')) {
        formInfo?.classList.add('show-noti-form');
        if (formSuccess) formSuccess.style.display = 'none';
        window.history.pushState('object', document.title, newURL);
      } else if (urlInfo.includes('customer_posted=true')) {
        formInfo?.classList.add('show-noti-form');
        if (formErr) formErr.style.display = 'none';
        _this.setCookie('bls-newsletter-popup', 99999, 'bls');
        window.history.pushState('object', document.title, newURL);
      } else if (urlInfo.includes('contact_posted=true#askquestion')) {
        formInfo?.classList.add('show-noti-form');
        if (formErr) formErr.style.display = 'none';
        window.history.pushState('object', document.title, newURL);
      }
    },

    checkShowMsgStockNotify: function () {
      const urlInfo = window.location.href;
      const fi = document.querySelector('.stock-notify,.close-form-stock-notify');
      if (fi) {
        fi.addEventListener('click', (e) => {
          e.preventDefault();
          e.currentTarget.closest('.stock-notify')?.classList.remove('show-noti-form');
        });
      }
      if (urlInfo.includes('contact_posted=true#FormStockNotify')) {
        const formInfo = document.querySelector('.stock-notify');
        formInfo?.classList.add('show-noti-form');
        window.history.pushState('object', document.title, location.href.split('?')[0]);
      }
    },
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => BlsPopup.init());
} else {
  BlsPopup.init();
}

var BlsLoginPopup = (function () {
  const parser = new DOMParser();
  let loginHTML = null;
  let isFetching = false;

  return {
    init: function () {
      this.showLogin();
    },

    clickTab: function () {
      const dialog = document.getElementById('loginp_0');
      if (!dialog) return;
      const hidden = dialog.querySelectorAll('[data-login-hidden]');
      const iTitle = dialog.querySelector('.dlg-heading .popup-title');
      dialog.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-login-show]');
        if (!trigger) return;
        e.preventDefault();
        const s = trigger.dataset.loginShow;
        hidden.forEach((eh) => {
          const isTarget = eh.dataset.loginHidden === s;
          eh.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
          if (isTarget && iTitle) iTitle.innerText = s;
        });
      });
    },

    showLogin: function () {
      const action = document.querySelector('.action-login');
      if (!action) return;
      const _this = this;
      action.addEventListener('mouseenter', () => _this._prefetch(), { once: true });
      action.addEventListener('focusin',    () => _this._prefetch(), { once: true });
      action.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('login-popup-show');
        _this._showDialog();
      });
    },

    _prefetch: function () {
      if (loginHTML || isFetching) return;
      this._fetchLogin();
    },

    _showDialog: function () {
      if (loginHTML) {
        this._createDialog(loginHTML);
      } else {
        this._fetchLogin(true);
      }
    },

    _fetchLogin: function (andShow = false) {
      if (isFetching) return;
      isFetching = true;
      const url = `${window.location.pathname}?section_id=login-popup`;
      const _this = this;
      fetch(url)
        .then(r => r.text())
        .then(responseText => {
          const html = parser.parseFromString(responseText, 'text/html');
          const l = html.querySelector('#login-popup');
          if (!l) return;
          loginHTML = l.innerHTML;
          isFetching = false;
          if (andShow) _this._createDialog(loginHTML);
        })
        .catch((e) => {
          isFetching = false;
          console.error('Login popup fetch failed:', e);
        });
    },

    _createDialog: function (innerHTML) {
      const _this = this;
      if (document.getElementById('loginp_0')) return;
      const titleEl = new DOMParser()
        .parseFromString(innerHTML, 'text/html')
        .querySelector('[data-title-default]');
      const title = titleEl?.dataset.titleDefault || '';
      var login = EasyDialogBox.create(
        'loginp',
        'dlg dlg-disable-footer dlg-disable-drag',
        title,
        innerHTML
      );
      login.onClose = login.destroy;
      login.show();
      login.onShow = () => _this.clickTab();
    },
  };
})();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => BlsLoginPopup.init());
} else {
  BlsLoginPopup.init();
}

var BlsLazyloadImg = (function () {
  return {
    init: function () {
      this.lazyReady();
    },
    lazyReady: function () {
      if (!!window.IntersectionObserver) {
        let observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // ✅ boundingClientRect comes from the IntersectionObserver entry —
                // this does NOT cause a forced reflow (it's already calculated)
                entry.target.width = entry.boundingClientRect.width;
                entry.target.height = entry.boundingClientRect.height;
                entry.target.sizes = `${entry.boundingClientRect.width}px`;
                entry.target.classList.add("bls-loaded-image");
                entry.target.closest(".bls-image-js")?.classList.remove("bls-loading-image");
                observer.unobserve(entry.target);
              }
            });
          },
          { rootMargin: "10px" }
        );
        document.querySelectorAll(".bls-image-js img").forEach((img) => {
          observer.observe(img);
        });
      }
    },
  };
})();
BlsLazyloadImg.init();

const rdc = {
  mode: "same-origin",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
};
const parser = new DOMParser();
const newMap = new Map();

var BlsReloadEvents = (function () {
  const sectionHandlers = {
    instagram:                () => BlsInstagramShopify?.init(),
    product_grid:             () => { BlsProductGridEvents?.init(); BlsProductTabEvents?.init(); BlsColorSwatchesShopify?.init(); },
    product_carousel:         () => { BlsProductGridEvents?.init(); BlsProductTabEvents?.init(); BlsColorSwatchesShopify?.init(); },
    recently_viewed_products: () => BlsRVProductsShopify?.init(),
    product_recommendations:  () => BlsProductRecommendsEvents?.init(),
    product_single:           () => BlsColorSwatchesShopify?.init(),
    product_deal:             () => { BlsColorSwatchesShopify?.init(); BlsCountdownTimer?.init(); },
  };

  return {
    init: function () {
      document.addEventListener("shopify:section:load", function (event) {
        const id = event.detail.sectionId;
        const section = event.target.querySelector(`[data-id="${id}"]`);
        if (!section) return;
        sectionHandlers[section.dataset.type]?.();
      });
    },
  };
})();

var BlsProductGridEvents = (function () {
  return {
    init: function () {
      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".bls__btn-load-more");
        if (!btn) return;
        const grid = btn.closest(".bls__grid");
        if (!grid) return;
        const sectionId = grid.dataset.id;
        const defClass = document.querySelector(".bls__load-more_wrap-" + sectionId);
        if (!defClass) return;

        const { nextUrl, currentPage, totalPages, totalItems } = defClass.dataset;
        const loadMoreBtn = defClass.querySelector('[type="button"]');
        if (!loadMoreBtn || loadMoreBtn.classList.contains("btn-loading")) return;

        const nextPage = parseInt(currentPage) + 1;
        loadMoreBtn.classList.add("btn-loading");

        const gridEl = document.getElementById(`bls__product-grid-${sectionId}`);
        if (!gridEl) { loadMoreBtn.classList.remove("btn-loading"); return; }

        const { id } = gridEl.dataset;

        fetch(`${nextUrl}?page=${nextPage}&section_id=${id}`)
          .then(r => r.text())
          .then(responseText => {
            const doc = parser.parseFromString(responseText, "text/html");
            const nodes = doc.querySelectorAll(`#bls__product-grid-${sectionId} .bls__product-load`);
            const fragment = document.createDocumentFragment();
            nodes.forEach(node => fragment.appendChild(node));
            gridEl.appendChild(fragment);
          })
          .catch(console.error)
          .finally(() => {
            loadMoreBtn.classList.remove("btn-loading");
            if (nextPage >= parseInt(totalPages)) {
              defClass.remove();
            } else {
              defClass.setAttribute("data-current-page", nextPage);
            }
            const allItems = gridEl.querySelectorAll(".bls__product-item");
            const limit = parseInt(totalItems);
            if (allItems.length > limit) {
              Array.from(allItems).slice(limit).forEach(el => el.remove());
              btn.remove();
            }
            BlsColorSwatchesShopify?.init();
            BlsSubActionProduct?.init();
            BlsReloadSpr?.init();
            BlsLazyloadImg?.init();
          });
      });
    },
  };
})();

var BlsProductTabEvents = (function () {
  return {
    init: function () {
      this.setupTabListeners();
      this.setupDropdownStyle();
      document.addEventListener("click", this.closeAllSelect);
    },

    setupTabListeners: function (activeTabId) {
      document.querySelectorAll(".bls__collection-tab").forEach((container) => {
        const tabItems = container.querySelectorAll(".bls__collection-tab-item");
        if (tabItems.length > 0) {
          container.addEventListener("click", function (e) {
            const item = e.target.closest(".bls__collection-tab-item");
            if (!item || item.classList.contains("active")) return;
            tabItems.forEach(t => t.classList.remove("active"));
            item.classList.add("active");
            const tabId = item.dataset.id;
            container.querySelectorAll(".bls__cls-tab").forEach(tab => {
              tab.classList.toggle("active", tab.id === tabId);
            });
          });
        } else if (activeTabId) {
          container.querySelectorAll(".bls__cls-tab").forEach(tab => {
            tab.classList.toggle("active", tab.id === activeTabId);
          });
        }
      });
    },

    setupDropdownStyle: function () {
      const _this = this;
      const selects = document.getElementsByClassName("custom-select");
      if (!selects.length) return;

      const arrowSVG = `<svg fill="currentColor" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg>`;

      Array.from(selects).forEach((wrapper) => {
        const selectEl = wrapper.getElementsByTagName("select")[0];
        if (!selectEl) return;

        wrapper.innerHTML = "";
        wrapper.appendChild(selectEl);

        const selected = document.createElement("div");
        selected.className = "select-selected flex justify-content-between w-full";
        const label = document.createElement("span");
        label.innerHTML = selectEl.options[selectEl.selectedIndex].innerHTML;
        const arrow = document.createElement("span");
        arrow.className = "select-arrow";
        arrow.innerHTML = arrowSVG;
        selected.appendChild(label);
        selected.appendChild(arrow);
        wrapper.appendChild(selected);

        const optionsList = document.createElement("div");
        optionsList.className = "select-items select-hide";

        const frag = document.createDocumentFragment();
        Array.from(selectEl.options).forEach((opt) => {
          const div = document.createElement("div");
          div.innerHTML = opt.innerHTML;
          if (opt.getAttribute("selected")) div.className = "same-as-selected";
          div.addEventListener("click", function () {
            for (let i = 0; i < selectEl.length; i++) {
              if (selectEl.options[i].innerHTML === this.innerHTML) {
                selectEl.selectedIndex = i;
                selected.childNodes[0].innerHTML = this.innerHTML;
                optionsList.querySelectorAll(".same-as-selected").forEach(el => el.removeAttribute("class"));
                this.className = "same-as-selected";
                break;
              }
            }
            selectEl.dispatchEvent(new Event("change"));
            selectEl.dispatchEvent(new Event("click"));
            selected.click();
          });
          frag.appendChild(div);
        });
        optionsList.appendChild(frag);
        wrapper.appendChild(optionsList);

        selected.addEventListener("click", function (e) {
          e.stopPropagation();
          _this.closeAllSelect(this);
          optionsList.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
          _this.setupTabListeners(wrapper.querySelector(".select-data")?.value);
        });
      });
    },

    closeAllSelect: function (elmnt) {
      const items = document.getElementsByClassName("select-items");
      const selected = document.getElementsByClassName("select-selected flex justify-content-between w-full");
      const skip = [];
      Array.from(selected).forEach((el, i) => {
        if (el === elmnt) skip.push(i);
        else el.classList.remove("select-arrow-active");
      });
      Array.from(items).forEach((el, i) => {
        if (!skip.includes(i)) el.classList.add("select-hide");
      });
    },
  };
})();

var BlsColorSwatchesShopify = (function () {
  return {
    init: function () {
      document.querySelectorAll(".bls__product-color-swatches").forEach(e => this.checkSwatches(e));

      document.querySelectorAll(".bls__product-item").forEach(productTarget => {
        let tooltipTimer;
        productTarget.addEventListener("mouseover", (e) => {
          const swatch = e.target.closest(".bls__option-swatch-js");
          if (!swatch) return;
          clearTimeout(tooltipTimer);
          this.listenerColor(swatch, productTarget);
          swatch.closest(".swiper")?.classList.add("show-tooltip");
        });
        productTarget.addEventListener("mouseout", (e) => {
          const swatch = e.target.closest(".bls__option-swatch-js");
          if (!swatch) return;
          const swiper = swatch.closest(".swiper");
          if (swiper) {
            tooltipTimer = setTimeout(() => swiper.classList.remove("show-tooltip"), 400);
          }
        });
      });
    },

    listenerColor: function (swatch, productTarget) {
      if (swatch.classList.contains("active")) return;
      const siblings = swatch.closest(".bls__product-option")?.querySelectorAll(".bls__option-swatch-js");
      siblings?.forEach(el => el.classList.remove("active"));
      swatch.classList.add("active");
      this.swapProduct(productTarget);
    },

    updateMasterId(options, variantData) {
      return variantData.find(variant =>
        !variant.options.map((opt, i) => options[i] === opt).includes(false)
      );
    },

    updatePrice(currentVariant, productTarget) {
      if (!currentVariant) return;
      const { compare_at_price, price, unit_price, unit_price_measurement } = currentVariant;
      const priceFormatted = Shopify.formatMoney(price, cartStrings?.money_format);

      if (unit_price && unit_price_measurement) {
        const unitNum = Shopify.formatMoney(unit_price, cartStrings?.money_format);
        const unitLabel = unit_price_measurement.reference_value !== 1
          ? unit_price_measurement.reference_value
          : unit_price_measurement.reference_unit;
        const upn = productTarget.querySelector(".unit-price .number");
        const upu = productTarget.querySelector(".unit-price .unit");
        if (upn) upn.innerHTML = unitNum;
        if (upu) upu.innerHTML = unitLabel;
      }

      const priceEl = productTarget.querySelector(".price__regular .price");
      if (priceEl) priceEl.innerHTML = priceFormatted;

      const priceBlock = productTarget.querySelector(".bls__price");
      if (!priceBlock) return;

      priceBlock.classList.remove("price--sold-out", "price--on-sale");
      priceBlock.querySelector(".price__regular .price")?.classList.remove("special-price");

      if (compare_at_price && compare_at_price > price) {
        const compareFormatted = Shopify.formatMoney(compare_at_price, cartStrings?.money_format);
        let compareEl = priceBlock.querySelector(".compare-price");
        if (!compareEl) {
          const ps = priceBlock.querySelector(".price__sale");
          const sp = document.createElement("span");
          compareEl = document.createElement("s");
          compareEl.className = "price-item compare-price";
          sp.appendChild(compareEl);
          ps?.appendChild(sp);
        }
        compareEl.innerHTML = compareFormatted;
        priceBlock.classList.add("price--on-sale");
        priceBlock.querySelector(".price__regular .price")?.classList.add("special-price");
      } else if (!currentVariant.available) {
        priceBlock.classList.add("price--sold-out");
      }
    },

    updateMedia(currentVariant, productTarget) {
      if (!currentVariant?.featured_media) return;
      setTimeout(() => {
        const img = productTarget.querySelector(".bls__product-main-img img");
        if (!img) return;
        img.removeAttribute("srcset");
        img.src = currentVariant.featured_media.preview_image.src;
      }, 200);
    },

    renderProductInfo(currentVariant, variantQtyData, productTarget) {
      if (!currentVariant) return;
      const { compare_at_price, price } = currentVariant;

      const vqd = variantQtyData.reduce((acc, item) => {
        const existing = acc.find(i => i.option === item.option);
        if (existing) {
          existing.qty += item.qty;
          if (item.available) existing.available = true;
          if (item.mamagement === "") existing.mamagement = "";
        } else {
          acc.push({ ...item });
        }
        return acc;
      }, []);

      const match = vqd.find(v => v.option === currentVariant.option1) || {};
      const { qty = 0, available: av = false, mamagement: im } = match;

      const sale = !!(compare_at_price && compare_at_price > price);
      const percent = sale ? ((compare_at_price - price) / compare_at_price) * 100 : 0;
      let sold_out = false, pre_order = false;

      if (im !== "") {
        if (av && qty < 1) pre_order = true;
        else if (!av) sold_out = true;
      }

      const getSaleText = () => {
        if (window.productLabel?.saleType === "price")
          return "- " + Shopify.formatMoney(compare_at_price - price, cartStrings.money_format);
        if (window.productLabel?.saleType === "percent")
          return percent.toFixed(0) + "%";
        return window.productLabel?.saleLabel || "";
      };

      const scrolling = productTarget.querySelector(".bls__product-text-scrolling");
      if (scrolling) {
        if (sale) {
          const raw = scrolling.dataset.textProductScrolling || "";
          const text = raw.replace("[percent_sale]", getSaleText());
          scrolling.querySelectorAll(".sale-content-product").forEach(el => el.innerText = text);
          scrolling.style.display = "flex";
        } else {
          scrolling.style.display = "none";
        }
      }

      productTarget.querySelector(".bls__product-label")?.remove();

      if (sale || pre_order || sold_out) {
        const labelDiv = document.createElement("div");
        labelDiv.className = "bls__product-label fs-12 pointer-events-none absolute";
        productTarget.querySelector(".bls__product-img")?.appendChild(labelDiv);

        if (sale) {
          const saleEl = document.createElement("div");
          saleEl.className = "bls__sale-label";
          saleEl.innerText = getSaleText();
          labelDiv.appendChild(saleEl);
        }
        if (sold_out) {
          const soldEl = document.createElement("div");
          soldEl.className = "bls__sold-out-label";
          soldEl.innerText = window.variantStrings?.soldOut || "Sold Out";
          labelDiv.appendChild(soldEl);
        }
        if (pre_order) {
          const preEl = document.createElement("div");
          preEl.className = "bls__pre-order-label";
          preEl.innerText = window.variantStrings?.preOrder || "Pre-order";
          labelDiv.appendChild(preEl);
        }
      }

      const cartDiv = productTarget.querySelector(".bls__product-addtocart-js");
      if (cartDiv && Number(cartDiv.dataset.productVariantId) !== currentVariant.id) {
        cartDiv.dataset.productVariantId = currentVariant.id;
      }

      this.toggleAddButton(!currentVariant.available, window.variantStrings?.soldOut, productTarget, pre_order);
    },

    toggleAddButton(disable = true, text, productTarget, pre_order = false) {
      const addBtn = productTarget?.querySelector(".bls__js-addtocart");
      if (!addBtn) return;
      const btnText = productTarget.querySelector(".bls__js-addtocart .bls__button-content");
      const tooltipText = productTarget.querySelector(".bls__js-addtocart .bls_tooltip-content");
      const setText = (str) => {
        if (btnText) btnText.textContent = str;
        if (tooltipText) tooltipText.textContent = str;
      };
      if (disable) {
        addBtn.setAttribute("disabled", "disabled");
        if (text) setText(text);
      } else {
        addBtn.removeAttribute("disabled");
        setText(pre_order
          ? (window.variantStrings?.preOrder || "Pre-order")
          : (window.variantStrings?.addToCart || "Add to cart")
        );
      }
    },

    setUnavailable(productTarget) {
      const addBtn = productTarget?.querySelector(".bls__js-addtocart");
      if (!addBtn) return;
      const text = window.variantStrings?.unavailable || "Unavailable";
      const btnText = productTarget.querySelector(".bls__js-addtocart .bls__button-content");
      const tooltipText = productTarget.querySelector(".bls__js-addtocart .bls_tooltip-content");
      if (btnText) btnText.textContent = text;
      if (tooltipText) tooltipText.textContent = text;
    },

    swapProduct: function (productTarget) {
      const activeSwatch = productTarget.querySelector(".bls__option-swatch-js.active");
      if (!activeSwatch) return;

      const variantData = JSON.parse(productTarget.querySelector(".productinfo")?.textContent || "[]");
      const variantQtyData = JSON.parse(productTarget.querySelector(".productVariantsQty")?.textContent || "[]");

      const position = activeSwatch.getAttribute("data-position");
      let options = Array.from(
        productTarget.querySelectorAll(".bls__option-swatch-js.active"),
        el => el.getAttribute("data-value")
      );

      if (options.length === 1) {
        const matched = variantData.find(v => {
          const map = { 1: v.option1, 2: v.option2, 3: v.option3 };
          return map[position] === options[0];
        });
        if (matched) options = matched.options;
      }

      const currentVariant = this.updateMasterId(options, variantData);
      this.toggleAddButton(true, "", productTarget);

      if (!currentVariant) {
        this.setUnavailable(productTarget);
      } else {
        this.updatePrice(currentVariant, productTarget);
        this.updateMedia(currentVariant, productTarget);
        this.renderProductInfo(currentVariant, variantQtyData, productTarget);
      }
    },

    checkSwatches: function (el) {
      const { color, image } = el?.dataset || {};
      if (!color) return;
      if (this.checkColor(color)) {
        el.style.backgroundColor = color;
      } else if (image) {
        el.classList.add("bls__" + color.replace(/\s+/g, "-"));
        el.style.cssText += ";background-color:null;background-image:url('" + image + "');background-size:cover;background-repeat:no-repeat";
      }
    },

    checkColor: function (strColor) {
      if (!this._colorTestEl) this._colorTestEl = new Option().style;
      this._colorTestEl.color = "";
      this._colorTestEl.color = strColor;
      return this._colorTestEl.color === strColor;
    },
  };
})();

var BlsCountdownTimer = (function () {
  const activeIntervals = [];
  function pad(n) { return String(n).padStart(2, "0"); }

  return {
    init: function () {
      activeIntervals.forEach(clearInterval);
      activeIntervals.length = 0;
      this.eventCountDownTimer();
      this.handleCountdown();
    },

    eventCountDownTimer: function () {
      const elements = document.querySelectorAll(".bls__countdown-timer");
      if (!elements.length) return;

      elements.forEach((el) => {
        const { days: dayLabel, hrs, secs, mins, time } = el.dataset;
        const countDownDate = new Date(time).getTime();
        if (isNaN(countDownDate)) return;
        const cd = el.querySelector(".bls__product-countdown");
        if (!cd) return;

        const timer = setInterval(() => {
          const distance = countDownDate - Date.now();
          if (distance < 0) { clearInterval(timer); return; }
          const d = Math.floor(distance / 86400000);
          const h = Math.floor((distance % 86400000) / 3600000);
          const m = Math.floor((distance % 3600000) / 60000);
          const s = Math.floor((distance % 60000) / 1000);
          cd.innerHTML = `
            <span class="countdown-days"><span class="countdown_ti heading-weight">${d}</span> <span class="countdown_tx">${dayLabel}</span></span>
            <span class="countdown-hours"><span class="countdown_ti heading-weight">${h}</span> <span class="countdown_tx">${hrs}</span></span>
            <span class="countdown-min"><span class="countdown_ti heading-weight">${m}</span> <span class="countdown_tx">${mins}</span></span>
            <span class="countdown-sec"><span class="countdown_ti heading-weight">${s}</span> <span class="countdown_tx">${secs}</span></span>`;
        }, 1000);

        activeIntervals.push(timer);
      });
    },

    handleCountdown: function () {
      const timers = document.querySelectorAll(".bls__timer");
      if (!timers.length) return;
      const MS = { day: 86400000, hour: 3600000, minute: 60000, second: 1000 };

      timers.forEach((el) => {
        const raw = el.dataset?.timer;
        if (!raw) return;
        const [mm, dd, yyyy] = raw.split("-");
        const isoDate = `${yyyy}-${mm.padStart(2,"0")}-${dd.padStart(2,"0")}T00:00:00Z`;
        const countDown = Date.parse(isoDate);
        if (!countDown) return;

        const daysEl   = el.querySelector(".js-timer-days");
        const hoursEl  = el.querySelector(".js-timer-hours");
        const minsEl   = el.querySelector(".js-timer-minutes");
        const secsEl   = el.querySelector(".js-timer-seconds");
        if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

        const timer = setInterval(() => {
          const now = Date.now();
          if (countDown < now) { clearInterval(timer); return; }
          const distance = countDown - now;
          const d = Math.floor(distance / MS.day);
          daysEl.innerText   = d < 10 ? pad(d) : d;
          hoursEl.innerText  = pad(Math.floor((distance % MS.day)    / MS.hour));
          minsEl.innerText   = pad(Math.floor((distance % MS.hour)   / MS.minute));
          secsEl.innerText   = pad(Math.floor((distance % MS.minute) / MS.second));
        }, 1000);

        activeIntervals.push(timer);
      });
    },
  };
})();

var BlsWishlistHeader = (function () {
  return {
    init: function () {
      const items = JSON.parse(localStorage.getItem("bls__wishlist-items"));
      const count = items?.length || 0;
      document.querySelectorAll(".bls-header-wishlist").forEach(el => {
        const badge = el.querySelector(".wishlist-count");
        if (badge) badge.innerText = count;
      });
    },
  };
})();

var BlsWishlistLoad = (function () {
  return {
    init: function (productHandle, wishlist_items) {
      if (!productHandle) return;
      const arr = wishlist_items ? [...wishlist_items] : [];
      const index = arr.indexOf(productHandle);

      if (index === -1) {
        arr.push(productHandle);
      } else {
        arr.splice(index, 1);
        const wishlistPage = document.querySelector(".bls__wishlist-page-section");
        if (wishlistPage) {
          document.querySelector(`.bls__wishlist-list[data-product-handle="${productHandle}"]`)?.remove();
          const remaining = wishlistPage.querySelectorAll(".bls__product-item");
          if (wishlist_items.length <= 1 || remaining.length < 1) {
            wishlistPage.querySelector(".bls__wishlist-no-product-js")?.classList.remove("d-none");
          }
        }
      }

      localStorage.setItem("bls__wishlist-items", JSON.stringify(arr));
      BlsSubActionProduct?.handleInitWishlist();
    },
  };
})();

var BlsCompareLoad = (function () {
  return {
    init: function (productTarget, compare_items) {
      if (!productTarget) return;
      const productHandle = productTarget.dataset.productHandle;
      const arr = compare_items ? [...compare_items] : [];
      const index = arr.indexOf(productHandle);

      if (index === -1) {
        arr.push(productHandle);
      } else {
        arr.splice(index, 1);
        const comparePage = document.querySelector(".bls__compare-page-section");
        if (comparePage) {
          document.querySelectorAll(`.bls__compare-value[data-product-handle="${productHandle}"]`).forEach(el => el.remove());
          const remaining = comparePage.querySelectorAll(".bls__product-item");
          if (compare_items.length <= 1 || remaining.length < 1) {
            comparePage.querySelector(".bls__compare-no-product-js")?.classList.remove("d-none");
            comparePage.querySelector(".bls__compare-table")?.classList.add("d-none");
          }
        }
      }

      localStorage.setItem("bls__compare-items", JSON.stringify(arr));
      BlsSubActionProduct?.handleInitCompare();
    },
  };
})();

(function () {
  function initAll() {
    BlsReloadEvents.init();
    BlsProductGridEvents.init();
    BlsProductTabEvents.init();
    BlsColorSwatchesShopify.init();
    BlsCountdownTimer.init();
    BlsWishlistHeader.init();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();

var BlsSubActionProduct = (function () {
  return {
    init: function () {
      this.handleInitQuickviewAction();
      this.handleActionWishlist();
      this.handleInitWishlist();
      this.handleActionCompare();
      this.handleInitCompare();
    },

    handleInitQuickviewAction: function () {
      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".bls__product-quickview");
        if (!btn) return;
        if (btn.classList.contains("btn-loading")) return;
        btn.classList.add("btn-loading");
        if (!btn.querySelector(".loader-icon")) {
          const loader = document.createElement("div");
          loader.className = "loader-icon";
          btn.appendChild(loader);
        }
        const productTarget = btn.closest(".bls__product-item");
        if (!productTarget) return;
        BlsSubActionProduct.handleFetchDataQuickView(btn, productTarget.dataset.productHandle);
      });
    },

    handleFetchDataQuickView: function (btn, handle) {
      if (!handle) return;
      fetch(`${window.Shopify.routes.root}products/${handle}/?section_id=product-quickview`)
        .then(r => r.text())
        .then(responseText => {
          const html = parser.parseFromString(responseText, "text/html");
          const el = html.querySelector("#shopify-section-product-quickview");
          if (!el) return;
          var qv = EasyDialogBox.create(
            "qvdialog",
            "dlg dlg-disable-heading dlg-multi dlg-disable-footer dlg-disable-drag",
            "",
            el.innerHTML
          );
          qv.onClose = qv.destroy;
          qv.show();
          BlsColorSwatchesShopify?.init();
          BlsReloadSpr?.init();
          Shopify?.eventFlashSold("dlg");
          Shopify?.eventCountDownTimer("dlg");
          Shopify?.swiperSlideQickview();
          BlsLazyloadImg?.init();
          Shopify?.PaymentButton?.init();
        })
        .catch(console.error)
        .finally(() => {
          BlsSubActionProduct.handleActionWishlist();
          BlsSubActionProduct.handleInitWishlist();
          BlsSubActionProduct.handleActionCompare();
          BlsSubActionProduct.handleInitCompare();
          BlsSubActionProduct.showPopupStockNotify();
          Shopify?.termsConditionsAction();
          btn.classList.remove("btn-loading");
          btn.querySelectorAll(".loader-icon").forEach(el => el.remove());
        });
    },

    handleInitWishlist: function () {
      const wishlistItems = JSON.parse(localStorage.getItem("bls__wishlist-items"));
      const isWishlistPage = !!document.querySelector(".bls__wishlist-page-section");

      document.querySelectorAll(".bls__product-wishlist").forEach(el => {
        const { proAddWishlist, proRemoveWishlist, removeWishlist, action } = el.dataset;
        const productHandle = el.dataset.productHandle;
        const icon = el.querySelector(".bls__product-icon");
        const tooltip = el.querySelector(".bls_tooltip-content");
        if (!icon || !tooltip) return;

        if (wishlistItems !== null && wishlistItems.indexOf(productHandle) !== -1) {
          icon.classList.add("active");
          tooltip.innerText = isWishlistPage
            ? (window.stringsTemplate?.messageRemoveWishlist || "")
            : (action === "remove" ? removeWishlist : proRemoveWishlist);
        } else {
          icon.classList.remove("active");
          tooltip.innerText = proAddWishlist || "";
        }
      });

      BlsWishlistHeader?.init();
    },

    handleActionWishlist: function () {
      document.removeEventListener("click", this._wishlistClickHandler);
      this._wishlistClickHandler = (e) => {
        const btn = e.target.closest(".bls__product-wishlist-js");
        if (!btn) return;
        e.preventDefault();
        BlsSubActionProduct.handleWishlistFunctionClick({ currentTarget: btn, preventDefault: () => {} });
      };
      document.addEventListener("click", this._wishlistClickHandler);
    },

    handleWishlistFunctionClick: function (evt) {
      evt.preventDefault();
      const btn = evt.currentTarget;
      const wishlistItems = JSON.parse(localStorage.getItem("bls__wishlist-items"));
      const productHandle = btn.dataset.productHandle;
      const action = btn.dataset.action;
      const isWishlistPage = !!document.querySelector(".bls__wishlist-page-section");

      if (isWishlistPage) {
        BlsWishlistLoad?.init(productHandle, wishlistItems);
      }

      const arr = wishlistItems ? [...wishlistItems] : [];
      const index = arr.indexOf(productHandle);

      if (index === -1) {
        arr.push(productHandle);
        localStorage.setItem("bls__wishlist-items", JSON.stringify(arr));
        BlsSubActionProduct.handleInitWishlist();
      } else {
        if (isWishlistPage) {
          arr.splice(index, 1);
          localStorage.setItem("bls__wishlist-items", JSON.stringify(arr));
        } else {
          if (action === "remove") {
            BlsWishlistLoad?.init(productHandle, wishlistItems);
          } else {
            window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/wishlist`;
          }
        }
      }
    },

    handleCompareFunctionClick: function (evt) {
      const btn = evt.currentTarget;
      const compareItems = JSON.parse(localStorage.getItem("bls__compare-items"));
      const productHandle = btn.dataset.productHandle;
      const arr = compareItems ? [...compareItems] : [];
      const index = arr.indexOf(productHandle);

      if (index === -1) {
        arr.push(productHandle);
        localStorage.setItem("bls__compare-items", JSON.stringify(arr));
        BlsSubActionProduct.handleInitCompare();
      } else {
        window.location.href = `${window.shopUrl}${window.Shopify.routes.root}pages/compare`;
      }
    },

    handleInitCompare: function () {
      const compareItems = JSON.parse(localStorage.getItem("bls__compare-items"));
      const isComparePage = !!document.querySelector(".bls__compare-page-section");

      document.querySelectorAll(".bls__product-compare").forEach(el => {
        const { proAddCompare, proRemoveCompare } = el.dataset;
        const productHandle = el.dataset.productHandle;
        const icon = el.querySelector(".bls__product-icon");
        const tooltip = el.querySelector(".bls_tooltip-content");
        if (!icon || !tooltip) return;

        if (compareItems !== null && compareItems.indexOf(productHandle) !== -1) {
          icon.classList.add("active");
          tooltip.innerText = isComparePage
            ? (window.stringsTemplate?.messageRemoveCompare || "")
            : (proRemoveCompare || "");
        } else {
          icon.classList.remove("active");
          tooltip.innerText = proAddCompare || "";
        }
      });
    },

    handleActionCompare: function () {
      document.removeEventListener("click", this._compareClickHandler);
      this._compareClickHandler = (e) => {
        const btn = e.target.closest(".bls__product-compare-js");
        if (!btn) return;
        BlsSubActionProduct.handleCompareFunctionClick({ currentTarget: btn });
      };
      document.addEventListener("click", this._compareClickHandler);
    },

    showPopupStockNotify: function () {
      document.removeEventListener("click", this._stockNotifyHandler);
      this._stockNotifyHandler = (e) => {
        const btn = e.target.closest(".product-notify-stock");
        if (!btn) return;
        e.preventDefault();
        BlsSubActionProduct.fetchDataStockNotifySection(btn.getAttribute("data-product-variant"));
      };
      document.addEventListener("click", this._stockNotifyHandler);
    },

    fetchDataStockNotifySection: function (variantId) {
      if (!variantId) return;
      fetch(`/variants/${variantId}/?section_id=stock-notify`)
        .then(r => r.text())
        .then(responseText => {
          const html = parser.parseFromString(responseText, "text/html");
          const el = html.querySelector("#bls-stock-notify");
          if (!el) return;
          const text = el.getAttribute("data-stock-title");
          var popup = EasyDialogBox.create(
            "stockNotify",
            "dlg dlg-multi dlg-disable-footer dlg-disable-drag",
            text,
            el.innerHTML
          );
          popup.center();
          popup.onClose = popup.destroy;
          popup.show();
        })
        .catch(console.error);
    },
  };
})();

var BlsSubActionProductPreLoad = (function () {
  return {
    handleActionPg: function () {
      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".bls__compare-remove-js");
        if (!btn) return;
        const productTarget = btn.closest(".bls__product-item");
        if (!productTarget) return;
        const compareItems = JSON.parse(localStorage.getItem("bls__compare-items"));
        BlsCompareLoad?.init(productTarget, compareItems);
      });
    },
  };
})();

var BlsReloadSpr = (function () {
  return {
    init: function () {
      if (!window.SPR) return;
      window.SPR.registerCallbacks();
      window.SPR.initRatingHandler();
      window.SPR.initDomEls();
      window.SPR.loadProducts();
      window.SPR.loadBadges();
    },
  };
})();

var BlsMainMenuShopify = (function () {
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  return {
    init: function () {
      this.initMainMenu();
      this.initVerticalMenu();
    },

    initMainMenu: function () {
      const _this = this;
      const header = document.querySelector(global.header);
      if (!header) return;

      const sticky = header.getAttribute("data-sticky");
      const stickyMobile = header.getAttribute("data-sticky-mobile");
      const verticalMenu = document.querySelector(".verticalmenu-list");
      const blsMainMenu = document.querySelector(".bls_main_menu");

      document.addEventListener("click", function (e) {
        const toggle = e.target.closest(".nav-toggle");
        if (!toggle) return;
        const isOpen = document.documentElement.classList.toggle("nav-open");
        if (!blsMainMenu) {
          document.documentElement.classList.toggle("nav-verticalmenu", isOpen);
        }
      });

      document.addEventListener("click", function (e) {
        const close = e.target.closest(".close-menu");
        if (!close) return;
        e.preventDefault();
        document.documentElement.classList.remove("nav-open");
        document.querySelectorAll(".submenu,.subchildmenu").forEach(item => {
          item.classList.remove("is--open", "is--open-lv2", "is--open-lv3");
        });
      });

      if (verticalMenu && blsMainMenu) {
        const article = document.querySelector(".verticalmenu-html");
        if (article) {
          const limitItemShow = article.dataset.limitshowitem;
          const mobileContent = blsMainMenu.querySelector(".mobile-menu-content");
          const mobileTitle = blsMainMenu.querySelector(".menu-mobile-title");
          const clone = document.createElement("ul");
          clone.className = "verticalmenu-list verticalmenu-mobile";
          clone.style.display = "none";
          clone.setAttribute("data-limitshowitem", limitItemShow);
          clone.innerHTML = verticalMenu.innerHTML;
          mobileContent?.appendChild(clone);
          const titleLink = `<a data-menu="verticalmenu-list" href="#">${window.menuStrings?.verticalTitle}</a>`;
          mobileTitle?.insertAdjacentHTML("beforeend", titleLink);
        }
      }

      document.addEventListener("click", function (e) {
        const tab = e.target.closest(".bls_main_menu .menu-mobile-title a");
        if (!tab) return;
        e.preventDefault();
        const data = tab.getAttribute("data-menu");
        document.querySelectorAll(".bls_main_menu .menu-mobile-title a").forEach(el => el.classList.remove("active"));
        tab.classList.add("active");
        document.querySelectorAll(".bls_main_menu .mobile-menu-content > ul").forEach(el => el.style.display = "none");
        const target = document.querySelector(".bls_main_menu ." + data);
        if (target) target.style.display = "block";
      });

      if (screen.width > 1024) {
        document.querySelectorAll("li.bls__menu-parent .submenu").forEach(submenu => {
          submenu.addEventListener("mouseenter", e => {
            e.currentTarget.closest(".bls__menu-parent")?.classList.add("bls-item-active-submenu");
          });
          submenu.addEventListener("mouseleave", e => {
            e.currentTarget.closest(".bls__menu-parent")?.classList.remove("bls-item-active-submenu");
          });
        });
      }

      document.querySelectorAll(".bls-menu-item.type_banner").forEach(item => {
        if (item.classList.contains("space-banner")) {
          item.closest(".submenu")?.classList.add("submenu-space-banner");
        }
      });

      const setHeaderCSSVars = () => {
      // ✅ All reads first
      const bar      = document.getElementById("announcement-bar")?.clientHeight || 0;
      const topbar   = document.getElementById("shopify-section-top-bar")?.clientHeight || 0;
      const headerH  = document.getElementById("page-header")?.clientHeight || 0;
      const sticky_h = document.getElementById("bls__sticky-addcart")?.clientHeight || 0;
      // ✅ setProperty instead of cssText — surgical update, no full style invalidation
      document.body.style.setProperty("--height-bar",    bar    + "px");
      document.body.style.setProperty("--height-header", headerH + "px");
      document.body.style.setProperty("--height-sticky", sticky_h + "px");
      return { bar, topbar, headerH, sticky_h };
    };

      const { bar, topbar } = setHeaderCSSVars();

      const handleResize = debounce((width) => {
        _this._applyResponsiveLayout(width);
      }, 150);

      window.addEventListener("resize", () => handleResize(window.innerWidth));
      window.addEventListener("load", () => {
        _this._applyResponsiveLayout(screen.width);
      }, { once: true });

      _this._applyResponsiveLayout(window.innerWidth);

      document.querySelectorAll("li.advanced-main a").forEach(item => {
        item.addEventListener("mouseenter", e => {
          const link = e.currentTarget;
          const data = link.getAttribute("data-link");
          if (!data) return;
          document.querySelectorAll("li.advanced-main a").forEach(el => el.classList.remove("active"));
          document.querySelectorAll("li.advanced-content > .sub").forEach(el => el.classList.remove("active"));
          link.classList.add("active");
          document.getElementById(data)?.classList.add("active");
        });
      });

      if (sticky === "true") {
        if (stickyMobile === "false" && window.innerWidth < 1025) return;

        const stickyEl = document.getElementById("sticky-header");
        if (!stickyEl) return;

        // ✅ Read offsetHeight once, before any DOM mutation
        const stickyH = stickyEl.offsetHeight;
        const threshold = bar + topbar + stickyH;

        const spacer = document.createElement("div");
        spacer.style.height = stickyH + "px";
        spacer.classList.add("headerSpace", "unvisible");
        stickyEl.after(spacer);

        // ✅ Cache these querySelector results — don't re-query inside scroll
        const headerMiddle = header.querySelector(".header-middle");
        const extentBar    = document.querySelector(".extent-button-right-bar");

        // ✅ FIX: Cache headerMiddle.offsetTop — reading it inside scroll = reflow every scroll tick
        let _cachedHeaderMiddleTop = null;
        const getHeaderMiddleTop = () => {
          if (_cachedHeaderMiddleTop === null) {
            _cachedHeaderMiddleTop = headerMiddle?.offsetTop || 0;
            window.addEventListener("resize", () => { _cachedHeaderMiddleTop = null; }, { passive: true });
          }
          return _cachedHeaderMiddleTop;
        };

        // ✅ Cache once — never query inside scroll/RAF
        const cachedOverlay      = document.querySelector(".bls__overlay");
        const cachedVerticalMenu = document.querySelector(".vertical-menu");

        let _stickyRafPending = false;
        window.addEventListener("scroll", function () {
          if (_stickyRafPending) return;
          _stickyRafPending = true;
          requestAnimationFrame(function () {
            _stickyRafPending = false;
            const scrollY = window.pageYOffset;

            if (scrollY <= getHeaderMiddleTop()) {
              if (header.classList.contains("transparent")) header.classList.add("transparent");
              return;
            }
            header.classList.remove("transparent");

            if (scrollY > threshold) {
              header.classList.add("header_scroll_down", "header_scroll_up");
              spacer.classList.remove("unvisible");
            } else {
              header.classList.remove("header_scroll_down");
              spacer.classList.add("unvisible");
              extentBar?.classList.remove("d-xxl-block");
              if (cachedOverlay) {
                document.documentElement.classList.remove("vetical-overlay");
                cachedOverlay.classList.add("d-none-overlay");
              }
              cachedVerticalMenu?.classList.remove("open");
            }
          });
        }, { passive: true });
      }

      if (blsMainMenu) {
        _this.loadImageMenu();
        if (window.innerWidth > 1024) _this.addCssSubMenu();
        window.addEventListener("resize", debounce(() => {
          if (window.innerWidth > 1024) _this.addCssSubMenu();
        }, 200));
      }
    },

    _applyResponsiveLayout: function (width) {
      const isMobile = width <= 1024;

      document.querySelectorAll("li.advanced-content > .sub").forEach((el, i) => {
        el.classList.toggle("active", !isMobile && i === 0);
      });

      if (isMobile) {
        if (document.querySelector(".show-localization")) {
          document.querySelector(".lang-curentcy")?.remove();
          document.querySelectorAll(".topbar localization-form").forEach(el => el.remove());
        } else {
          document.querySelectorAll(".disclosure-mobile").forEach(el => el.remove());
        }

        const categoriesMenu = document.querySelector("[data-menu='categories-list']");
        const verticalMenu   = document.querySelector("[data-menu='verticalmenu-list']");
        if (document.querySelector(".verticalmenu-mobile")) {
          document.querySelector(".categories-list-menu-mobile")?.remove();
          categoriesMenu?.remove();
        }

        const horizontalList   = document.querySelector(".horizontal-list");
        const categoriesMobile = document.querySelector(".categories-list-menu-mobile");
        const verticalMobile   = document.querySelector(".verticalmenu-mobile");

        if (horizontalList && (categoriesMenu?.classList.contains("active") || verticalMenu?.classList.contains("active"))) {
          horizontalList.style.display = "none";
        }
        if (categoriesMobile && categoriesMenu?.classList.contains("active")) {
          categoriesMobile.style.display = "block";
        }
        if (verticalMobile && verticalMenu?.classList.contains("active")) {
          verticalMobile.style.display = "block";
        }
      } else {
        const categoriesMenu   = document.querySelector("[data-menu='categories-list']");
        const verticalMenu     = document.querySelector("[data-menu='verticalmenu-list']");
        const horizontalList   = document.querySelector(".horizontal-list");
        const categoriesMobile = document.querySelector(".categories-list-menu-mobile");
        const verticalMobile   = document.querySelector(".verticalmenu-mobile");

        if (categoriesMobile && categoriesMenu?.classList.contains("active")) {
          categoriesMobile.style.display = "none";
        }
        if (verticalMobile && verticalMenu?.classList.contains("active")) {
          verticalMobile.style.display = "none";
        }
        if (horizontalList && (categoriesMenu?.classList.contains("active") || verticalMenu?.classList.contains("active"))) {
          horizontalList.style.display = "block";
        }
      }
    },

    initVerticalMenu: function () {
      const article = document.querySelector(".verticalmenu-html");
      if (!article) return;

      const limitItemShow = parseInt(article.dataset.limitshowitem) || 999;
      const items = document.querySelectorAll(".verticalmenu-html .level0");
      const width = screen.width;

      if (width > 1024 && items.length > limitItemShow) {
        const itemsArr = Array.from(items);
        itemsArr.forEach((el, i) => {
          if (i >= limitItemShow && !el.classList.contains("expand-menu-link")) {
            el.classList.add("orther-link");
            el.style.display = "none";
          }
        });

        const expandLink = document.querySelector(".verticalmenu-html .expand-menu-link");
        if (expandLink) {
          expandLink.style.display = "block";
          expandLink.querySelector("a")?.addEventListener("click", e => {
            e.preventDefault();
            const parent = e.currentTarget.parentElement;
            const isExpanding = parent.classList.toggle("expanding");
            e.currentTarget.innerHTML = isExpanding
              ? window.menuStrings?.hideMenus
              : window.menuStrings?.moreMenus;
            document.querySelectorAll(".verticalmenu-html .level0.orther-link").forEach(el => {
              isExpanding ? showAnime(el) : hideAnime(el);
            });
          });
        }
      } else {
        document.querySelector(".expand-menu-link")?.style.setProperty("display", "none");
      }

      document.querySelector(".bls_vertical_menu .title-menu-dropdown")
        ?.addEventListener("click", e => {
          e.preventDefault();
          const menu = e.currentTarget.closest(".vertical-menu");
          const isOpen = menu?.classList.toggle("open");
          const overlay = document.querySelector(".bls__overlay");
          if (overlay) {
            document.documentElement.classList.toggle("vetical-overlay", isOpen);
            overlay.classList.toggle("d-none-overlay", !isOpen);
          }
        });
    },

    addCssSubMenu: function () {
      const bodyWidth = document.documentElement.clientWidth || document.body.clientWidth;
      if (bodyWidth < 1024) return;

      const padding = bodyWidth < 1200 ? 15 : 30;
      const subCenter = document.querySelector(".bls_submenu-center");
      const subCenterWidth = Number(
        document.querySelector("[data-width-sub-center]")?.getAttribute("data-width-sub-center") || 0
      );

      const submenus = document.querySelectorAll(".horizontal-list .menu-width-custom > .submenu");

      // ✅ FIX: BATCH READ phase — collect all layout values before any writes
      // Interleaving read/write inside forEach was causing reflow per iteration
      const measurements = Array.from(submenus).map(submenu => ({
        el:          submenu,
        rect:        subCenter ? submenu.getBoundingClientRect() : null,
        clientWidth: !subCenter ? submenu.clientWidth  : 0,
        offsetLeft:  !subCenter ? submenu.offsetLeft   : 0,
      }));

      // ✅ BATCH WRITE phase — no layout reads here
      measurements.forEach(({ el, rect, clientWidth, offsetLeft }) => {
        if (subCenter) {
          if (subCenterWidth <= rect.width) {
            el.style.left = ((rect.left - (rect.right - bodyWidth)) / 2) + "px";
          }
        } else {
          if (bodyWidth - (clientWidth + offsetLeft) < 0) {
            let left = bodyWidth - (clientWidth + offsetLeft) + offsetLeft - padding;
            if (offsetLeft < 0) left = 0;
            el.style.left = left + "px";
          }
        }
      });
    },

    loadImageMenu: function () {
      document.addEventListener("mouseover", function (e) {
        const menuParent = e.target.closest(".bls__menu-parent");
        if (!menuParent) return;
        menuParent.querySelectorAll(".menu-banner-loaded").forEach(item => {
          if (item.querySelector(".image-banner-loaded")) return;
          const { imageBanner, width, height } = item.dataset;
          if (!imageBanner) return;
          item.innerHTML = `<img src="${imageBanner}" alt="Menu banner" srcset="${imageBanner}&width=375 375w, ${imageBanner}&width=750 750w, ${imageBanner}&width=1100 1100w, ${imageBanner}&width=1500 1500w" sizes="100vw" class="image-banner-loaded" loading="lazy" width="${width}" height="${height}">`;
        });
      });
    },
  };
})();

var BlsMenuActionMobile = (function () {
  return {
    init: function () {
      this.menuTabActions();
    },

    menuTabActions: function () {
      const windowWidth = window.innerWidth;

      if (windowWidth <= 1024) {
        document.querySelectorAll("li.bls__menu-parent > a").forEach(link => {
          const main = link.closest(".main-nav")?.getAttribute("data-action-mobile");
          if (main === "false") {
            link.removeAttribute("href");
            link.classList.add("not-links");
            link.setAttribute("role", "link");
          }
        });
      }

      document.addEventListener("click", function (e) {

        const menuToggle = e.target.closest("li.bls__menu-parent > .open-children-toggle");
        if (menuToggle) {
          const parent = menuToggle.parentElement;
          const submenu = parent.querySelector(".submenu");
          if (submenu) {
            const lv2Nodes = parent.querySelectorAll(".submenu [data-menu-level2]");
            lv2Nodes[lv2Nodes.length - 1]?.classList.add("last-child");
            submenu.classList.toggle("is--open");
          }
          return;
        }

        if (e.target.closest(".back-main-menu")) {
          e.preventDefault();
          e.target.closest(".back-main-menu").closest(".submenu")?.classList.remove("is--open");
          return;
        }

        const lv2Toggle = e.target.closest("[data-menu-level2]");
        if (lv2Toggle) {
          const parent = lv2Toggle.parentElement;
          parent.querySelector(".subchildmenu")?.classList.toggle("is--open");
          return;
        }

        if (e.target.closest(".back-main-menu-lv1")) {
          e.preventDefault();
          document.querySelectorAll(".subchildmenu").forEach(el => el.classList.remove("is--open"));
          return;
        }

        if (e.target.closest(".back-main-menu-lv2")) {
          e.preventDefault();
          e.target.closest(".back-main-menu-lv2").closest(".subchildmenu")?.classList.remove("is--open-lv2");
          return;
        }

        if (e.target.closest(".back-main-menu-lv3")) {
          e.preventDefault();
          e.target.closest(".back-main-menu-lv3").closest(".subchildmenu")?.classList.remove("is--open-lv3");
          return;
        }

        const dropLv2 = e.target.closest(".submenu .dropdown li.level-1 > .open-children-toggle");
        if (dropLv2) {
          const parent = dropLv2.parentElement;
          parent.querySelector("li .subchildmenu")?.classList.toggle("is--open-lv2");
          return;
        }

        const dropLv3 = e.target.closest(".submenu .dropdown li.level-2 > .open-children-toggle");
        if (dropLv3) {
          const parent = dropLv3.parentElement;
          parent.querySelector("li .subchildmenu")?.classList.toggle("is--open-lv3");
          return;
        }
      });
    },
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  if (window.BlsSubActionProduct)        BlsSubActionProduct.init();
  if (window.BlsSubActionProductPreLoad) BlsSubActionProductPreLoad.handleActionPg();
  if (window.BlsMainMenuShopify)         BlsMainMenuShopify.init();
  if (window.BlsMenuActionMobile)        BlsMenuActionMobile.init();
});

const BlsSearchShopify = (function () {
  const cachedResults = {};
  let searchInput, predictiveSearch, searchForm;

  return {
    init() {
      predictiveSearch = document.querySelector("#predictive-search");
      searchForm       = document.querySelector("#search-form");
      searchInput      = document.querySelector('#search-form input[type="search"]');

      if (!searchForm) return;

      if (predictiveSearch) {
        this.setupEventListeners();
      }

      document.querySelectorAll(".top-search-toggle").forEach(toggle => {
        toggle.addEventListener("click", () => {
          const opened = searchForm.classList.contains("bls__opend-popup-header");
          searchForm.classList.toggle("bls__opend-popup-header");
          document.documentElement.classList.toggle("hside_opened");
          document.documentElement.classList.toggle("open-search");
          if (!opened) setTimeout(() => searchInput.focus(), 100);
        });
      });

      document.querySelectorAll(".mini_search_header .button-close").forEach(btn => {
        btn.addEventListener("click", () => {
          searchForm.classList.remove("bls__opend-popup-header");
          document.documentElement.classList.remove("hside_opened", "open-search");
        });
      });
    },

    setupEventListeners() {
      const form = document.querySelector("form.search");
      form.addEventListener("submit", this.onFormSubmit.bind(this));
      searchInput.addEventListener("input", this.debounce(event => this.onChange(event), 300));
      searchInput.addEventListener("focus", this.onFocus.bind(this));
      document.addEventListener("focusout", this.onFocusOut.bind(this));
      document.addEventListener("keyup", this.onKeyup.bind(this));
    },

    debounce(fn, wait = 300) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    getQuery() { return searchInput.value.trim(); },

    onChange() {
      const term = this.getQuery();
      if (!term.length) { this.close(true); return; }
      this.getSearchResults(term);
    },

    onFormSubmit(event) {
      if (!this.getQuery().length) event.preventDefault();
    },

    onFocus() {
      const term = this.getQuery();
      if (!term.length) return;
      if (predictiveSearch.classList.contains("results")) {
        this.open();
      } else {
        this.getSearchResults(term);
      }
    },

    onFocusOut() {
      setTimeout(() => {
        if (!document.contains(document.activeElement)) this.close();
      });
    },

    onKeyup(event) {
      if (!this.getQuery().length) { this.close(true); return; }
      switch (event.code) {
        case "ArrowUp":   this.switchOption("up");   break;
        case "ArrowDown": this.switchOption("down"); break;
        case "Enter":     this.selectOption();       break;
      }
    },

    switchOption(direction) {
      const moveUp   = direction === "up";
      const selected = document.querySelector('[aria-selected="true"]');
      const items    = predictiveSearch.querySelectorAll("li");
      let active     = items[0];
      if (moveUp && !selected) return;
      if (!moveUp && selected) active = selected.nextElementSibling || items[0];
      if (moveUp  && selected) active = selected.previousElementSibling || items[items.length - 1];
      if (selected) selected.setAttribute("aria-selected", false);
      active.setAttribute("aria-selected", true);
      searchInput.setAttribute("aria-activedescendant", active.id);
    },

    selectOption() {
      const selected = predictiveSearch.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');
      if (selected) selected.click();
    },

    getSearchResults(term) {
      const key = term.replace(" ", "-").toLowerCase();
      if (cachedResults[key]) { this.renderSearchResults(cachedResults[key]); return; }

      const section = document.querySelector(".search_type_popup")
        ? "search-predictive-grid"
        : "search-predictive-list";

      const url = `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=product,collection,query&resources[limit]=6&section_id=${section}`;

      this.setLiveRegionLoadingState();

      fetch(url, { cache: "force-cache" })
        .then(res => res.text())
        .then(text => {
          const html = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(`#shopify-section-${section}`).innerHTML;
          cachedResults[key] = html;
          this.renderSearchResults(html);
        })
        .catch(() => this.close());
    },

    setLiveRegionLoadingState() {
      searchForm.classList.add("loading");
      predictiveSearch.classList.add("loading");
    },

    setLiveRegionResults() {
      searchForm.classList.remove("loading");
      predictiveSearch.classList.remove("loading");
    },

    renderSearchResults(html) {
      document.querySelector("[data-predictive-search]").innerHTML = html;
      predictiveSearch.classList.add("results");
      this.setLiveRegionResults();
      this.open();
      BlsColorSwatchesShopify?.init();
      BlsLazyloadImg?.init();
    },

    open() {
      searchInput.setAttribute("aria-expanded", true);
      this.isOpen = true;
    },

    close(clear = false) {
      if (clear) {
        searchInput.value = "";
        predictiveSearch.classList.remove("results");
      }
      const selected = predictiveSearch.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute("aria-selected", false);
      searchInput.setAttribute("aria-activedescendant", "");
      searchInput.setAttribute("aria-expanded", false);
      this.isOpen = false;
    },
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  BlsSearchShopify.init();
});

const BlsUminoAdminLi = (() => {
  function init() {
    if (typeof umino_app !== "object") return;
    if (umino_app.mode !== "admin") return;
    checkLicense();
  }

  function checkLicense() {
    const url = `https://api.nextsky.co/api/check-license/?code=${umino_app.lic}&domain=${umino_app.shop}`;
    fetch(url)
      .then(r => r.json())
      .then(res => { if (!res.d) console.warn("Theme license invalid."); })
      .catch(console.error);
  }

  return { init };
})();

document.addEventListener("DOMContentLoaded", () => { BlsUminoAdminLi.init(); });
BlsUminoAdminLi.init();

class SkeletonPage extends HTMLElement {
  constructor() {
    super();
    fetch(`${window.Shopify.routes.root}?section_id=skeleton-page`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = newParser.parseFromString(responseText, "text/html");
        const p = html.querySelector("#bls__skeleton");
        if (p) this.innerHTML = p.innerHTML;
      })
      .catch((e) => { throw e; });
  }
}
customElements.define("skeleton-page", SkeletonPage);

class HeaderTotalPrice extends HTMLElement {
  constructor() { super(); }
  updateTotal(cart) {
    this.minicart_total = this.querySelector("[data-cart-subtotal-price]");
    if (!this.minicart_total) return;
    if (cart.total_price == undefined) return;
    this.minicart_total.innerHTML = Shopify.formatMoney(cart.total_price, cartStrings?.money_format);
  }
}
customElements.define("header-total-price", HeaderTotalPrice);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.init(this.dataset.order);
  }
  init(orders) {
    const fe_unavaiable = this.dataset.feUnavaiable;
    const fe_avaiable   = this.dataset.feAvaiable;
    const rate          = Number(Shopify.currency.rate);
    const min           = Number(this.dataset.feAmount);
    if (!min || !rate) return;
    const order          = Number(orders) / 100;
    const min_by_currency = min * rate;
    if (order == undefined) return;
    const pct = (order / min_by_currency) * 100;
    this.setProgressBar(pct > 100 ? 100 : pct);
    this.setProgressBarTitle(order, min_by_currency, fe_unavaiable, fe_avaiable);
  }
  setProgressBarTitle(order, min_by_currency, fe_unavaiable, fe_avaiable) {
    const title = this.querySelector(".free-shipping-message");
    if (!title) return;
    title.classList.remove("opacity-0");
    if (order >= min_by_currency) {
      title.innerHTML = fe_avaiable;
    } else {
      const ammount = "{{ amount }}";
      title.innerHTML = fe_unavaiable.replace(
        ammount.trim(),
        Shopify.formatMoney((min_by_currency - order) * 100, cartStrings.money_format)
      );
    }
  }
  setProgressBar(progress) {
    const p = this.querySelector(".progress");
    p.style.width = progress + "%";
    this.classList.toggle("cart_shipping_free", progress === 100);
  }
}
customElements.define("free-ship-progress-bar", ProgressBar);

class SlideImageShopable extends HTMLElement {
  constructor() { super(); this.init(); }
  init() { this.BlsCarousel(); }
  BlsCarousel() {
    var element = this.querySelector(".bls__swiper-shopable");
    var autoplaying = element.dataset.autoplay === "true";
    var loop        = element.dataset.loop === "true";
    var dataArrowCenterImage = element.dataset.arrowCenterimage ? element.dataset.arrowCenterimage : 0;
    var itemDesktop = element.dataset.desktop ? element.dataset.desktop : 1;
    var itemTablet  = element.dataset.tablet  ? element.dataset.tablet  : 1;
    var itemMobile  = element.dataset.mobile  ? element.dataset.mobile  : 1;
    var spacing     = Number(element.dataset.spacing || 0);

    new Swiper(element, {
      slidesPerView: itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplaying,
      loop: loop,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: element.querySelector(".swiper-button-next-item"),
        prevEl: element.querySelector(".swiper-button-prev-item"),
      },
      pagination: {
        clickable: true,
        el: element.querySelector(".swiper-pagination-item"),
        type: "progressbar",
      },
      breakpoints: {
        768:  { slidesPerView: itemTablet,  spaceBetween: spacing >= 30 ? 30 : spacing },
        1200: { slidesPerView: itemDesktop, spaceBetween: spacing },
      },
      on: {
        init: function () {
          if (dataArrowCenterImage) {
            var items_slide = element.querySelectorAll(".bls__responsive-image");
            if (items_slide.length !== 0) {
              // ✅ FIX: Batch all reads first
              var max = 0;
              items_slide.forEach((e) => {
                const h = e.offsetHeight / 2;
                if (h > max) max = h;
              });
              // ✅ Then single write
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              element.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                arrow.setAttribute('style', arrowsOffset);
              });
            }
          }
        },
      },
    });
  }
}
customElements.define('slide-image-shopable', SlideImageShopable);

document.addEventListener("shopify:section:load", function (event) {
  var id      = event.detail.sectionId;
  var section = event.target.querySelector(`[data-id="${id}"]`);
  if (section) {
    var element    = section.querySelector(".bls__swiper");
    var customSlide = section.querySelector(".slideshow-custom");
    var testimonial = section.querySelector(".bls__testimonial");
    var counter     = section.querySelector(".bls__counter");
    if (customSlide)  BlsCustomSlideShow?.init();
    if (element)      BlsSettingsSwiper.BlsCarousel(element);
    if (testimonial)  BlsSettingsSwiperTestimonial?.init();
    if (counter)      BlsCounterEvent?.init();
  }
  if (id) BlsLazyloadImg.init();
});

class productList extends HTMLElement {
  constructor() {
    super();
    this.carousel_mobile  = Boolean(this.dataset.carouselmobile);
    this.gridCustomColumn = this.dataset.gridCustomcolumn;
    this.gapTablet        = this.dataset.gridGaptablet;
    this.gapMobile        = this.dataset.gridGapmobile;
    this.carousel_arrows  = this.dataset.swippercontrol;
    this.carouselpagination = this.dataset.carouselpagination;
    this.items = this.querySelectorAll(".product-list_item");
    this.init();
  }

  init() {
    var _this = this;
    if (this.carousel_mobile) {
      if (window.innerWidth <= 768) {
        _this.CarouselView();
      }
      window.addEventListener("resize", () => {
        if (window.innerWidth > 768) {
          _this.className = `row row-cols-xl-${_this.gridCustomColumn} ${_this.gapTablet} ${_this.gapMobile}`;
          _this.innerHTML = "";
          _this.items.forEach((item) => {
            _this.appendChild(item);
            item.style = "";
            item.classList.remove("swiper-slide");
            item.classList.add("product-list_item", "col-sm-6");
          });
        } else {
          _this.CarouselView();
        }
      });
    }
  }

  CarouselView() {
    var _this = this;
    _this.className = `swiper bls__swiper hover__show-nav`;
    let swiper = this.querySelector(".swiper-wrapper");
    if (!swiper) {
      var swiper_wrapper = document.createElement("div");
      swiper_wrapper.classList.add("swiper-wrapper");
      _this.items.forEach((item) => {
        swiper_wrapper.appendChild(item);
        item.classList.add("swiper-slide", "product-list_item");
        item.classList.remove("col-sm-6");
      });
      if (this.carousel_arrows) {
        let carousel_arrows = document.createElement("div");
        carousel_arrows.classList.add("swipper-next-back");
        carousel_arrows.innerHTML = `<div class="swiper-arrow swiper-next swiper-button-next box-shadow"><i class="icon-chevron-right"></i></div><div class="swiper-arrow swiper-prev swiper-button-prev box-shadow"><i class="icon-chevron-left"></i></div>`;
        _this.appendChild(carousel_arrows);
      }
      if (this.carouselpagination === 'carousel_bullets' || this.carouselpagination === 'show_bullet_mobile' || this.carouselpagination === 'carousel_pagination_progress') {
        let carouselpagination = document.createElement("div");
        carouselpagination.classList.add("swiper-pagination");
        _this.appendChild(carouselpagination);
      }
      _this.appendChild(swiper_wrapper);
      _this.BlsCarousel(_this);
    }
  }

  BlsCarousel(e) {
    var autoplaying = e?.dataset.autoplay === "true";
    var loop        = e?.dataset.loop === "true";
    var dataArrowCenterImage = e?.dataset.arrowCenterimage ? e?.dataset.arrowCenterimage : 0;
    var itemDesktop = e?.dataset.desktop     ? e?.dataset.desktop     : 4;
    var itemTablet  = e?.dataset.tablet      ? e?.dataset.tablet      : 2;
    var itemMobile  = e?.dataset.mobile      ? e?.dataset.mobile      : 1;
    var autoplaySpeed = Number(e?.dataset.autoplaySpeed || 3000);
    var speed       = Number(e?.dataset.speed    || 400);
    var effect      = e?.dataset.effect      ? e?.dataset.effect      : "slide";
    var sectionId   = e?.dataset.sectionId;
    var row         = e?.dataset.row         ? e?.dataset.row         : 1;
    var spacing     = Number(e?.dataset.spacing  || 0);
    var progressbar = e?.dataset.paginationProgressbar === "true";
    var autoItem    = e?.dataset.itemMobile  === "true";
    var autoplayConfig;
    if (autoplaying) autoplayConfig = { delay: autoplaySpeed };

    var sliderGlobal = new Swiper("#bls__swiper-" + sectionId, {
      slidesPerView: autoItem ? "auto" : itemMobile,
      spaceBetween: spacing >= 15 ? 15 : spacing,
      autoplay: autoplayConfig,
      loop: loop,
      effect: effect,
      speed: speed,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      grid: { rows: row, fill: "row" },
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      pagination: {
        clickable: true,
        el: e.querySelector(".swiper-pagination"),
        type: progressbar ? "progressbar" : "bullets",
      },
      breakpoints: {
        768:  { slidesPerView: itemTablet,  spaceBetween: spacing >= 30 ? 30 : spacing },
        1200: { slidesPerView: itemDesktop, spaceBetween: spacing },
      },
      on: {
        init: function () {
          if (dataArrowCenterImage) {
            var swiper = document.getElementById("bls__swiper-" + sectionId);
            var items_slide = swiper.querySelectorAll(".product-list_item");
            if (items_slide.length !== 0) {
              // ✅ FIX: Batch READ all heights first
              var max = 0;
              items_slide.forEach((el) => {
                const h = el.offsetHeight / 2;
                if (h > max) max = h;
              });
              // ✅ Single WRITE
              var arrowsOffset = '--arrows-offset-top: ' + max + 'px';
              swiper.querySelectorAll('.swiper-arrow').forEach((arrow) => {
                arrow.setAttribute('style', arrowsOffset);
              });
            }
          }
        },
      },
    });
  }
}
customElements.define('product-list', productList);